import { render } from "./Alumnos.vue?vue&type=template&id=178218d0&scoped=true"
import script from "./Alumnos.vue?vue&type=script&lang=js"
export * from "./Alumnos.vue?vue&type=script&lang=js"

import "./Alumnos.vue?vue&type=style&index=0&id=178218d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178218d0"]])

export default __exports__